import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HumanCapitalContractActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/Contract/ContractBrowser")
	}

	render() {
		return (
			<Activity 
				name="HumanCapitalContract"
				RenderedComponent={this.RenderedComponent}
				context="HumanCapitalContract"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HumanCapitalContractActivity)
